import { createGlobalStyle } from "styled-components"

const GlobalStyle = createGlobalStyle`
html{scroll-behavior: smooth}
*{box-sizing: border-box}
p{font-family: 'Montserrat', sans-serif !important; margin: 0; padding: 0}
div{box-sizing: border-box;}
body{margin:auto; float:none; font-family: 'Montserrat', sans-serif !important;font-weight: 400; color:#3C3C3B; box-sizing: border-box;}
a{font-family: 'Montserrat',sans-serif; text-decoration:none; color: inherit;}
img{ width:100%;height:auto;}
h1,h2,h3,h4,h5,h6{font-family: 'Montserrat', sans-serif;margin:0;}
h1{ font-size:48px;line-height:48px; font-weight:700; margin-bottom:10px;color:#7C7A7A;}
h2{ font-size:32px;line-height:40px; font-weight:700; margin-bottom:32px;}
h3{ font-size:24px;line-height:28px; margin-bottom:16px;}
h4{ font-size:18px;line-height:26px; margin-bottom:16px;}
ul {list-style: none; padding: 0; margin: 0; box-sizing: border-box}
li {box-sizing: border-box}
button {border: none; background: transparent; padding: 0}
nav {padding: 0}

//Scroll bar
ul::-webkit-scrollbar, div::-webkit-scrollbar {background: transparent; width: 7px;  opacity: 0.5 !important;}
ul:hover::-webkit-scrollbar, div:hover::-webkit-scrollbar { opacity: 0.5 !important; visibility: visible !important;}
ul::-webkit-scrollbar-thumb, div::-webkit-scrollbar-thumb {background: rgba(0, 183, 255, 0.2); border: 1px solid #00b7ff;}

p{font-family: 'Montserrat', sans-serif; font-size:18px;line-height:30px;font-weight: 400; margin:0;margin-bottom:32px;}

hr{ border:1px solid #4E50F7; width:100%;margin:64px 0;box-sizing: border-box;}

.svg-icon{ width:38px;height:25px;color:#4E50F7;float:right;}
.svg-icon path{fill:#4E50F7;}

#download input{border:none;border-bottom:1px solid white;border-radius:0;font-size: 12px;padding: 8px 0px;margin: 16px 0px 0px;}
#download select{margin-top:16px;height: 30px;color: #888;}
#download span{font-size: 12px;}
#download button{text-transform:capitalize;background-color: transparent;margin: 32px 0px 0px;color:#4E50F7;border: 2px solid #4E50F7;}
#download button:hover{background-color:#4E50F7;color:#fff;}
#download p{ font-size:14px;}
.inputwrap{
	box-sizing: border-box;
	margin: 16px 0px 0px;
	min-width: 0px;
	display: block;
	width: 100%;
	padding: 8px 0px;
	appearance: none;
	line-height: inherit;
	color: inherit;
	background-color: transparent;
	font-size: 12px;
	border-top: medium none;
	border-right: medium none;
	border-left: medium none;
	border-image: none 100% / 1 / 0 stretch;
	outline: currentcolor none medium;
	border-radius: 0px;
	border-bottom: 1px solid #D1D1D1;
}
#download .inputwrapselect>div{
    width: 100% !important;
    position: relative !important;
}
#download .inputwrapselect ul{
    width: 100%;
    top: 60px;
}
#download .inputwrapselect button{
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    padding: 0 8px;
    min-width: 230px;
    min-height: 38px;
    background: transparent;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 1rem;
    font-weight: 500;
    cursor: default;
    background: #2A95BF;
    color: #fff;
    position: relative;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    z-index: 30;
    line-height: 1.62;
    -webkit-transition: 0.3s;
    transition: 0.3s;
    border: none;
}

@media (max-width: 767px) {
  h1{font-size:40px;line-height:45px;}
}

@media (max-width: 599px) {
  h1{font-size:30px;line-height:35px;}
  h2{font-size:27px;line-height:34px;margin-bottom:20px;}
  h3{ font-size:20px;}
  p{font-size:15px;line-height:25px;margin-bottom:15px;}
}

`
export default GlobalStyle
